// maybe should do codes like en-US to distinguish accents
// https://developers.deepgram.com/docs/language
export type LanguageCode = 'en' | 'zh' | 'es' | 'hi' | 'ar' | 'bn' | 'ru' | 'pt' | 'ja' | 'de';
export const languageMap: Record<LanguageCode, string> = {
    'en': 'English',
    'zh': 'Chinese',
    'es': 'Spanish',
    'hi': 'Hindi',
    'ar': 'Arabic',
    'bn': 'Bengali',
    'ru': 'Russian',
    'pt': 'Portuguese',
    'ja': 'Japanese',
    'de': 'German'
};
/**
 * media processing
seperating vocals
seperating background
Translating..
generating voices
Merging dubs!
finished
 */
export enum statusType {
    Uploading = "uploading",
    Uploaded = "Uploaded",
    Translating = "Generating Voices",
    Translated = "Finished",
    Scheduled = "scheduled",
    Posted = "posted",
    Failed = "failed"
};

export interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}